import {
	Home7,
	SubtopicFinalTeam7,
	Theme7Introduction,
	Theme7SubtopicOneActivityOne,
	Theme7SubtopicOneActivityTwo,
	Theme7SubtopicOneFinalPoints,
	Theme7SubtopicTwoActivityFour,
	Theme7SubtopicTwoActivityOne,
	Theme7SubtopicTwoActivityThree,
	Theme7SubtopicTwoActivityTwo,
	Theme7SubtopicTwoFinalPoints
} from "../pages/tema7";



export const pathTeam7 = {
	path: "home7",
	element: <Home7></Home7>,
	children: [
		{
			path: "tema7",
			children: [
				{
					path: "introduction",
					element: <Theme7Introduction></Theme7Introduction>
				},
				{
					path: "subtema1",
					children: [
						{
							path: "activityOne",
							element: <Theme7SubtopicOneActivityOne></Theme7SubtopicOneActivityOne>
						},
						{
							path: "activityTwo",
							element: <Theme7SubtopicOneActivityTwo></Theme7SubtopicOneActivityTwo>
						},
						{
							path: "activityresult",
							element: <Theme7SubtopicOneFinalPoints></Theme7SubtopicOneFinalPoints>
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							path: "activityOne",
							element: <Theme7SubtopicTwoActivityOne></Theme7SubtopicTwoActivityOne>
						},
						{
							path: "activityTwo",
							element: <Theme7SubtopicTwoActivityTwo></Theme7SubtopicTwoActivityTwo>
						},
						{
							path: "activityThree",
							element: <Theme7SubtopicTwoActivityThree></Theme7SubtopicTwoActivityThree>
						},
						{
							path: "activityFour",
							element: <Theme7SubtopicTwoActivityFour></Theme7SubtopicTwoActivityFour>
						},
						{
							path: "activityresult",
							element: <Theme7SubtopicTwoFinalPoints></Theme7SubtopicTwoFinalPoints>
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTeam7></SubtopicFinalTeam7>
				},
			],
		}
	]
}